import React from "react";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField, Typography } from "@mui/material";
import { ownerApi } from "../../../../api/owner";
import { formatApiError } from "../../../../api/client";

function idOf(value) {
  return String(value?.id || value?._id || value || "");
}

export default function OwnerCommitmentScheduleDialog({ open, commitment, onClose, onSaved }) {
  const [scheduledStartAt, setScheduledStartAt] = React.useState("");
  const [saving, setSaving] = React.useState(false);
  const [error, setError] = React.useState("");

  React.useEffect(() => {
    if (!open) return;
    setScheduledStartAt("");
    setError("");
  }, [open, commitment]);

  const submit = async () => {
    const id = idOf(commitment);
    const when = scheduledStartAt ? new Date(scheduledStartAt) : null;
    if (!id) return;
    if (!when || Number.isNaN(when.getTime())) {
      setError("Elegí la nueva fecha y hora.");
      return;
    }
    if (when.getTime() <= Date.now()) {
      setError("La nueva fecha y hora tiene que estar en el futuro.");
      return;
    }
    setSaving(true);
    setError("");
    try {
      await ownerApi.updateCommitment(id, { scheduledStartAt: when.toISOString() });
      await onSaved?.();
      onClose?.();
    } catch (err) {
      setError(formatApiError(err, "No pude mover este bloque."));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={Boolean(open)} onClose={saving ? undefined : onClose} fullWidth maxWidth="xs">
      <DialogTitle>
        <Typography sx={{ fontWeight: 1000 }}>Mover bloque</Typography>
        <Typography sx={{ color: "text.secondary", fontSize: ".75rem" }}>{commitment?.title}</Typography>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={1.1} sx={{ pt: .7 }}>
          <Typography sx={{ color: "text.secondary", fontWeight: 720, fontSize: 12.5 }}>
            Sólo cambia el horario del mismo pendiente. Proyecto, estado, prioridad y demás datos quedan intactos.
          </Typography>
          <TextField
            autoFocus
            required
            fullWidth
            type="datetime-local"
            label="Nueva fecha y hora"
            InputLabelProps={{ shrink: true }}
            value={scheduledStartAt}
            onChange={(event) => setScheduledStartAt(event.target.value)}
          />
          {error ? <Alert severity="error">{error}</Alert> : null}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={saving} sx={{ textTransform: "none", fontWeight: 850 }}>Cancelar</Button>
        <Button variant="contained" disabled={saving || !scheduledStartAt} onClick={submit} sx={{ textTransform: "none", fontWeight: 950 }}>
          {saving ? "Moviendo…" : "Mover"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
